<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心
    -->
    <el-dialog
        title="补充信息"
        :visible.sync="dialogVisible"
        @close="dialogFormVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="70%"
       :append-to-body="true"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
    
 

      <div class="common-form">基础信息</div>

      <el-form-item label="供应商资质：" prop="credential">
      <div class="draggable-list">
        <draggable class="wrapper" >
          <transition-group>
            <div v-for="(item, index) in form.credential" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'credential')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('credential')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>


      <el-form-item label="供应商案例：" prop="cases">
      <div class="draggable-list">
        <draggable class="wrapper" >
          <transition-group>
            <div v-for="(item, index) in form.cases" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'cases')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('cases')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>


    <el-form-item label="供应商设备：" prop="equipment">
      <div class="draggable-list">
        <draggable class="wrapper" >
          <transition-group>
            <div v-for="(item, index) in form.equipment" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'equipment')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('equipment')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>



 
      <!-- <el-form-item label="门店简介" >
        <div class="edit_container">
          <Uediter :text="form.summary" :config="ueditor.config" ref="ue" @contentChange="contentChangeFunc"></Uediter>
        </div>
      </el-form-item>
 -->


      <div class="common-form">身份证</div>
      <el-form-item label="身份证号码" prop="idcard">
        <el-input v-model="form.idcard" placeholder="请输入身份证号码" class="max-w460"></el-input>
      </el-form-item>


      <el-form-item label="身份证正面：" prop="idcard_positive">
      <div class="draggable-list">
      
            <div>
              <div class="item">
                <img v-img-url="form.idcard_positive" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(0,'idcard_positive')"><i class="el-icon-close"></i></a>
              </div>
            </div>
    
        <div class="item img-select" @click="openProductUpload('idcard_positive')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>


    <el-form-item label="身份证反面：" prop="idcard_reverse">
      <div class="draggable-list">
 
            <div >
              <div class="item">
                <img v-img-url=" form.idcard_reverse" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(0,'idcard_reverse')"><i class="el-icon-close"></i></a>
              </div>
            </div>
 
        <div class="item img-select" @click="openProductUpload('idcard_reverse')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>


<!-- 
    <div class="common-form">营业执照：</div>
      <el-form-item label="营业执照：" prop="business_license">
      <div class="draggable-list">
        <draggable class="wrapper" >
          <transition-group>
            <div v-for="(item, index) in form.business_license" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'business_license')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('business_license')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item> -->


    <div class="common-form">银行卡：</div>
    <el-form-item label="卡号" prop="bank_card">
        <el-input v-model="form.bank_card" placeholder="请输入卡号" class="max-w460"></el-input>
      </el-form-item>


      <el-form-item label="卡号正面：" prop="bank_positive">
      <div class="draggable-list">
 
            <div >
              <div class="item">
                <img v-img-url="form.bank_positive" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(0,'bank_positive')"><i class="el-icon-close"></i></a>
              </div>
            </div>
      
        <div class="item img-select" @click="openProductUpload('bank_positive')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>


    <el-form-item label="卡号反面：" prop="bank_reverse">
      <div class="draggable-list">
 
            <div >
              <div class="item">
                <img v-img-url="form.bank_reverse" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(0,'bank_reverse')"><i class="el-icon-close"></i></a>
              </div>
            </div>
  
        <div class="item img-select" @click="openProductUpload('bank_reverse')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>



      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 50 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>

     </div>
</el-dialog>
  
</template>

<script>
import SupplyApi from '@/api/supply.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     draggable,
     Uediter
  },
  data() {
    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,  
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入阳光房订单名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
         code:"album",
         product:[],
         isVideoUpload:false,
         isFileUpload:false,

    };
  },
  created() {
    this.dialogVisible = this.open_add;
  },
  props: ["open_add","supply_id",'form'],
  methods: {
  

     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },

     /*获取图片*/
     returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
          this.form.image = e[0].file_path;
          this.isImg = true;
        
      }
      this.isupload = false;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", result);
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    onSubmit() {
      let self = this;
      let form = self.form;
  
      form.supply_id = self.supply_id;
   
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          SupplyApi.osedit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },
    openVideoUpload:function (code) {
      this.isVideoUpload = true;
      this.code = code
    },
    openFileUpload:function (code) {
      this.isFileUpload = true;
      this.code = code
    },


     /*上传商品图片*/
     returnProductImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["jpg", "png",'jpeg'];
        let prevent = false;
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
        // let setting = this.form.setting;
        console.log('this.code',this.code);
        if(this.code == 'business_license'){
            let business_license = this.form.business_license;
            var obj = e
            business_license =obj[0].file_path
            this.form.business_license = business_license;
            
            this.$set(this.form, "business_license", business_license);
        }else if(this.code == 'idcard_positive'){
            let idcard_positive = this.form.idcard_positive;
            var obj = e
            idcard_positive =obj[0].file_path
            this.form.idcard_positive = idcard_positive;
            
            this.$set(this.form, "idcard_positive", idcard_positive);
        }else if(this.code == 'idcard_reverse'){
            let idcard_reverse = this.form.idcard_reverse;
            var obj = e
            idcard_reverse =obj[0].file_path
            this.form.idcard_reverse = idcard_reverse;
            
            this.$set(this.form, "idcard_reverse", idcard_reverse);
        }else if(this.code == 'bank_positive'){
            let bank_positive = this.form.bank_positive;
            var obj = e
            bank_positive =obj[0].file_path
            this.form.bank_positive = bank_positive;
            
            this.$set(this.form, "bank_positive", bank_positive);
        }else if(this.code == 'bank_reverse'){
            let bank_reverse = this.form.bank_reverse;
            var obj = e
            bank_reverse =obj[0].file_path
            this.form.bank_reverse = bank_reverse;
            
            this.$set(this.form, "bank_reverse", bank_reverse);
          }else if(this.code == 'cases'){
            let cases = this.form.case;
            var obj = e
            cases =cases .concat(obj)
            this.form.case = cases;
            
            this.$set(this.form, "cases", cases);
        }else if(this.code == 'credential'){
            let credential = this.form.credential;
            var obj = e
            credential =credential .concat(obj)
            this.form.case = credential;
            
            this.$set(this.form, "credential", credential);
        }else if(this.code == 'equipment'){
            let equipment = this.form.equipment;
            var obj = e
            equipment =equipment.concat(obj)
            this.form.equipment = equipment;
            
            this.$set(this.form, "equipment", equipment);
        }
       
      }
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'business_license'){
        this.form.business_license = "";
      }else if(code == 'idcard_positive'){
        this.form.idcard_positive = "";
      }else if(code == 'idcard_reverse'){
        this.form.idcard_reverse = "";
      }else if(code == 'bank_positive'){
        this.form.bank_positive = "";
      }else if(code == 'bank_reverse'){
        this.form.bank_reverse = "";
      }else if(code == 'cases'){
        this.form.cases.splice(index, 1);
      }else if(code == 'credential'){
        this.form.credential.splice(index, 1);
      }else if(code == 'equipment'){
        this.form.equipment.splice(index, 1);
      }
      
    },
       /*获取富文本内容*/
       contentChangeFunc(e) {
      this.form.summary = e;
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/user/supply/oss.vue